export const AVATAR_TYPES = {
  SKINNABLE: "skinnable",
  URL: "url",
  PERSISTENCE: "persistence"
};

const PERSISTENCE_ASSET_ID_PATTERN = /^\/assets\/[^/.?#/]+$/i;
const GLTF_PATH_PATTERN = /\.(glb|gltf)$/i;
const HTTP_URL_PATTERN = /^https?:\/\//i;

function toPathname(value) {
  try {
    return new URL(value, "http://localhost").pathname;
  } catch {
    return value;
  }
}

export function getAvatarType(avatarId) {
  if (typeof avatarId !== "string") return AVATAR_TYPES.SKINNABLE;

  const normalizedAvatarId = avatarId.trim();
  const pathname = toPathname(normalizedAvatarId);

  if (PERSISTENCE_ASSET_ID_PATTERN.test(pathname)) return AVATAR_TYPES.PERSISTENCE;
  if (GLTF_PATH_PATTERN.test(pathname)) return AVATAR_TYPES.URL;
  if (HTTP_URL_PATTERN.test(normalizedAvatarId)) return AVATAR_TYPES.URL;

  return AVATAR_TYPES.SKINNABLE;
}
